import React, { Component } from 'react'
import ReactSelect from 'react-select'
import PropTypes from 'prop-types'

export default class AttributeFilterSelect extends Component {
  static propTypes = {
    collection: PropTypes.array.isRequired,
    attribute: PropTypes.string.isRequired,
    selected: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    ...Component.propTypes
  }

  constructor (props) {
    super(props)
    this.state = {
      options: [{ label: 'All', value: null }]
    }

    this.buildOptions()
  }

  buildOptions () {
    const { collection, attribute } = this.props
    collection.forEach(
      item => {
        if (
          item[attribute] &&
          this.state.options.findIndex(option => option.value === item[attribute]) === -1
        ) {
          this.state.options.push({
            label: item[attribute],
            value: item[attribute]
          })
        }
      }
    )
  }

  get placeholder () {
    return this.props.selected || 'All'
  }

  render () {
    return (
      <ReactSelect
        className={this.props.className || 'filter_select'}
        searchable={false}
        clearable={false}
        name="date-select"
        placeholder={this.placeholder}
        options={this.state.options}
        onChange={option => this.props.onChange(option.value)}
        aria-label="Genre Select"
      />
    )
  }
}
